import React from "react";

import { Badge, Dropdown, Image } from "react-bootstrap";
import { Table } from "react-bootstrap";

// import CardDropdown from "../../components/CardDropdown";

const TableRow = ({
  data,
  sr,
  viewEntry,
  updateEntry,
  deleteEntry,
  propLength,
}) => {
  return (
    <tr className="align-middle text-center">
      <td>{sr}</td>
      <td className="text-primary" style={{ cursor: "pointer" }} onClick={() => viewEntry(data)}>
        #{data.orderNumber}
      </td>
      {/* <td>{data.user?.email || data.user}</td>
      <td>
        {data.assigned_distributor?.first_name || data.assigned_distributor}
      </td> */}
      <td>Rs. {data.totalAmount}</td>
      <td>
        <Badge
          bg={
            data.status === "Processing"
              ? "warning"
              : data.status === "Shipped"
              ? "info"
              : data.status === "Delivered"
              ? "success"
              : "danger"
          }
        >
          {data.status}
        </Badge>
      </td>
      <td>
        <Badge
          bg={
            data.paymentStatus === "Unpaid"
              ? "secondary"
              : data.paymentStatus === "Pending"
              ? "warning"
              : data.paymentStatus === "Paid"
              ? "success"
              : "danger"
          }
        >
          {data.paymentStatus}
        </Badge>
      </td>
      <td>{data.paymentMethod}</td>
      <td>{new Date(data.createdAt).toLocaleDateString()}</td>
    </tr>
  );
};

const OrdersTable = ({ list = [], viewEntry, updateEntry, deleteEntry }) => {
  let i = 1;
  return (
    <Table responsive hover bordered style={{ fontSize: "14px" }}>
      <thead>
        <tr className="text-center">
          <th>#</th>
          <th>Order Number</th>
          {/* <th>User</th>
          <th>Distributor</th> */}
          <th>Total Amount</th>
          <th>Status</th>
          <th>Payment</th>
          <th>Method</th>
          <th>Created</th>
        </tr>
      </thead>

      <tbody>
        {list?.map((entry, index) => (
          <TableRow
            data={entry}
            key={index}
            sr={i++}
            propLength={list?.length}
            viewEntry={viewEntry}
            updateEntry={updateEntry}
            deleteEntry={deleteEntry}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default OrdersTable;
